export const testimonials = [
  {
    id: "t-01",
    name: "一颗安静的瓜",
    role: "常驻讨论区 · 3 年",
    rating: 5,
    content:
      "最喜欢的是这里能把同一个事件的不同立场摆在一起看。以前刷到一条评论就下判断，现在会先翻翻讨论区，发现原来还有完全不同的理解。",
  },
  {
    id: "t-02",
    name: "不追星只追剧",
    role: "影视分区活跃用户",
    rating: 5,
    content:
      "大结局那天，讨论区比剧本身还好看。有人整理时间线，有人贴出原著对比，观点不同但都讲道理，这种氛围现在挺难得的。",
  },
  {
    id: "t-03",
    name: "后排吃瓜选手",
    role: "综艺分区用户",
    rating: 4,
    content:
      "名场面盘点做得很细致，连镜头调度都分析了。唯一的建议是希望能多一些幕后视角的内容，光是讨论有点不过瘾。",
  },
  {
    id: "t-04",
    name: "通勤路上的耳朵",
    role: "音乐 / 演出分区用户",
    rating: 5,
    content:
      "音乐节穿搭那篇看完直接去下单了防水外套。好的内容就是能落地，不只是一堆形容词堆在一起。",
  },
  {
    id: "t-05",
    name: "内容行业搬砖人",
    role: "行业观察关注者",
    rating: 4,
    content:
      "短剧那篇的完播率分析挺有参考价值，行业视角不算深，但把关键变量讲清楚了，适合快速建立判断。",
  },
  {
    id: "t-06",
    name: "只发表情包",
    role: "网络热梗分区用户",
    rating: 5,
    content:
      "热梗的传播路径梳理得很有意思，原来一个梗从出现到全网模仿会经历这么多阶段。看完感觉自己也能预测下一个爆点了。",
  },
];